import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import getUser from "../../utils/getUser";
import TextField from "@material-ui/core/TextField";

export default function CopyLinkDialog({ open, onClose }) {
    const user = getUser();

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <DialogTitle>Your personal referral link</DialogTitle>
                <DialogContent dividers>
                    <DialogContentText id="alert-dialog-description">
                        {open &&
                            <TextField inputRef={(ref) => ref && setTimeout(() => ref.select(), 100)} style={{width: 550}} variant={'outlined'} value={`https://new-tab.studio/join/${user.id}`} />
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}